import { useEffect, useState } from 'react';

import { DEFAULT_SUPPORT_EMAIL } from 'config';
import { publicSettings } from 'services/api/publicSettingsClient';

let cachedSupportEmail: string | null = null;
let pendingRequest: Promise<string> | null = null;

const loadSupportEmail = (): Promise<string> => {
  pendingRequest ??= Promise.resolve()
    .then(() => publicSettings.get())
    .then((response) => {
      const email = response?.data?.support_email;
      if (!email) throw new Error('Support email unavailable');
      cachedSupportEmail = email;
      return email;
    })
    .catch(() => {
      // Keep the shipped address and try again on the next page that asks.
      pendingRequest = null;
      return DEFAULT_SUPPORT_EMAIL;
    });
  return pendingRequest;
};

/** Support address from Admin > Operations, falling back to the shipped default. */
export const useSupportEmail = (): string => {
  const [supportEmail, setSupportEmail] = useState(cachedSupportEmail ?? DEFAULT_SUPPORT_EMAIL);

  useEffect(() => {
    if (cachedSupportEmail) return undefined;
    let isMounted = true;
    void loadSupportEmail().then((email) => { if (isMounted) setSupportEmail(email); });
    return () => { isMounted = false; };
  }, []);

  return supportEmail;
};

/** Test-only: forget the cached address. */
export const resetSupportEmailCache = () => {
  cachedSupportEmail = null;
  pendingRequest = null;
};
